import { useEffect } from "react";
import { ChequeActivityData, ChequeActivityDelete } from "../types";
import { ChequeForm } from "../../../cheque";
import { BANKS } from "../../../../constants";
import { Column } from "../../../containers";
import { Heading } from "../../../typography";
import { usePopupStore, useThemeStore } from "../../../../stores";
import { TextInput } from "../../../inputs";
import { PopupBack, PopupClose } from "../../../../popup";
import { BackContainer } from "../../../../types";

const ChequeDeleteActivityPopup = <T extends {}>(
  props: BackContainer<ChequeActivityData, T>
) => {
  const activity = props.data as ChequeActivityDelete;
  const theme = useThemeStore((s) => s.theme);
  const setPopupProperties = usePopupStore((s) => s.setPopupProperties);

  useEffect(() => {
    setPopupProperties({
      style: {
        maxHeight: "80%",
        overflowY: "auto",
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props]);

  return (
    <Column style={{ padding: "1rem 2rem", position: "relative" }}>
      <PopupClose />

      {props.back ? (
        <PopupBack Component={props.back.component} props={props.back.props} />
      ) : (
        <></>
      )}

      <Heading
        size={18}
        textStyles={{ marginBottom: "1rem" }}
        color={theme.textOnOverlay}
      >
        حذف چک
      </Heading>

      <ChequeForm
        {...activity}
        readOnly
        file={null}
        bank={{
          name: activity.bank,
          fa: BANKS.filter((b) => b.name === activity.bank)[0].fa,
        }}
      />

      {activity.confirmed_with ? (
        <TextInput
          style={{ marginTop: "1rem" }}
          label="تایید شده به نام"
          value={activity.confirmed_with}
        />
      ) : (
        <></>
      )}
    </Column>
  );
};

export default ChequeDeleteActivityPopup;
